import { SELECT_PRODUCT } from 'quick-quote/product-selection/actions'
import { RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE } from 'quick-quote/product-sio/actions'
import { RESET_APPLICATION_STATE, RESET_QUOTE_FORM } from 'quick-quote/actions'

import { validateTitle } from 'core/service/insured'
import { getGender, getAge } from 'quick-quote/insured-information/selectors'
import { isKid } from 'core/service/insured/age'
import VALUES from 'core/data-model/constants/values'
import title from 'e-submission/mocks/title.json'

const defaultState = {
  name: '',
  defaultValue: '',
  errors: [],
}

const redux = (validateTitle) => (namespace, initialState) => {
  const finalInitialState = initialState || defaultState

  // actions
  const EDIT_NAME = `${namespace}/EDIT_NAME`
  const editTitle = (payload) => ({
    type: EDIT_NAME,
    payload,
  })
  const CLEAR_NAME = `${namespace}/CLEAR_NAME`

  // reducer
  const reducer = (state = finalInitialState, action) => {
    switch (action.type) {
      case SELECT_PRODUCT:
        return state
      case CLEAR_NAME:
      case RESET_QUOTE_FORM:
      case RESET_QUOTE_FORM_AFTER_MATURITY_VALIDATE:
      case RESET_APPLICATION_STATE:
        return { ...state, name: '', errors: [] }
      case EDIT_NAME:
        let inputPayload =
          action.payload.length > VALUES.TITLE_MAX_LENGTH
            ? action.payload.substring(0, VALUES.TITLE_MAX_LENGTH)
            : action.payload
        return {
          ...state,
          name: inputPayload,
          errors: validateTitle(inputPayload),
        }
    }

    return state
  }
  // selectors
  const getTitle = (state) => (state ? state.name : '')
  const getErrors = (state) => (state ? state.errors : '')
  const getOptions = (state) => {
    if (!state.insured) return
    const gender = getGender(state)
    const age = getAge(state)
    const options = isKid(age) ? title.kid : title.default
    return options.filter((opt) => !opt.gender || opt.gender === gender)
  }
  const getDefaultValue = (state) => {
    return { value: '', text: '' }
  }

  return {
    initialState: finalInitialState,
    actions: { EDIT_NAME },
    actionCreators: { editTitle },
    reducer,
    selectors: { getTitle, getDefaultValue, getErrors, getOptions },
  }
}

export default redux

export const TitleRedux = redux(validateTitle)('TITLE')
